<script module lang="ts">
  import type { IconCardStoryblokProps } from './icon-card.types';
  import type { Snippet } from 'svelte';

  export interface IconCardProps extends IconCardStoryblokProps {
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { Card, CardContent } from '@agapi/ui/card';
  import { storyblokEditable, StoryblokComponent } from '@storyblok/svelte';
  import RichText from '../rich-text/rich-text.svelte';
  import { css } from '@agapi/ui/panda/css';
  import { iconCardStyles } from './icon-card.styles';
  import DynamicIcon from '../../../components/dynamic-icon/dynamic-icon.svelte';

  const { blok }: IconCardProps = $props();

  const styles = iconCardStyles.raw({
    direction: blok.direction ?? 'vertical'
  });
</script>

<Card
  use={[[storyblokEditable, blok]]}
  spacing="tight"
  css={{ height: 'full' }}
>
  <CardContent css={styles.content}>
    <div class={css(styles.icon)}>
      <DynamicIcon name={blok.icon} size={24} />
    </div>

    <div class={css(styles.content)}>
      <h3 class={css({ textStyle: 'h4', maxWidth: '100%' })}>{blok.title}</h3>
      <div class={css({ textStyle: 'body' })}>
        {#if blok.description}
          <RichText blok={{ body: blok.description }} />
        {/if}
      </div>

      {#if blok.button?.[0]}
        <div class={css({ mt: 'auto', pt: '4' })}>
          <StoryblokComponent blok={blok.button[0]} />
        </div>
      {/if}
    </div>
  </CardContent>
</Card>
